import React from 'react'
import styled from 'styled-components'
import _ from 'underscore'

import ErrorMessage from 'components/ErrorMessage'
import Tooltip from 'components/Tooltip'

type Props = {
  id: string,
  label?: string,
  isRequired?: boolean,
  errorMessage?: string,
  className?: string,
  children: React.ReactNode;
}

const LabelledField = ({ children, id, label, isRequired = false, errorMessage, className }: Props) => (
  <S.LabelledField {...{ className }}>
    {!_.isEmpty(label?.trim()) && <S.Label htmlFor={id}>{label}</S.Label>}
    {isRequired && (
      <Tooltip title={`${label} is required`} placement="top">
        <strong> *</strong>
      </Tooltip>
    )}
    {children}
    <S.ErrorMessage id={id} errorMessage={errorMessage} />
  </S.LabelledField>
)

export default LabelledField

const S = {
  LabelledField: styled.div`
    margin-bottom: 15px;
  `,
  Label: styled.label`
    display: inline;
  `,
  ErrorMessage: styled(ErrorMessage)`
    padding-top: 5px;
    margin-bottom: -25px;
  `
}
